export enum HookStatusEnum {
    Success = 'success',
    Failed = 'failed',
    Pending = 'pending',
}
